<template>
  <div class="list-provider">
    <KTCodePreview v-bind:title="'Danh sách nhà cung cấp'">
      <template v-slot:toolbar>
        <div class="row">
          <b-button
            v-show="checkPermission('PROVIDER_VIEW')"
            variant="outline-secondary"
            size="sm"
            class="btn btn-secondary font-weight-bolder btn-sm mr-2"
            @click="handleExport"
          >
            <i
              style="font-size: 1rem"
              class="fa fa-file-download"
            ></i
            >Xuất Excel
          </b-button>
          <b-button
            v-if="false"
            v-show="checkPermission('PROVIDER_INSERT')"
            variant="outline-info"
            size="sm"
            class="btn btn-info font-weight-bolder btn-sm mr-2"
            @click="handleImport"
          >
            <i
              style="font-size: 1rem"
              class="fa fa-file-import"
            ></i
            >Nhập Excel
          </b-button>

          <router-link to="/providers/add-provider">
            <b-button
              v-if="false"
              v-show="checkPermission('PROVIDER_INSERT')"
              variant="primary"
              size="sm"
              class="btn btn-primary font-weight-bolder btn-sm"
            >
              <i
                style="font-size: 1rem"
                class="flaticon2-add-1"
              ></i
              >Tạo mới
            </b-button>
          </router-link>
        </div>
      </template>
      <template v-slot:preview>
        <div class="col-md-12">
          <div class="row">
            <div
              class="col-md-3"
              style="padding-left: 0"
            >
              <b-form>
                <b-form-group>
                  <b-form-input
                    type="text"
                    size="sm"
                    @input="onFilter"
                    v-model="name"
                    placeholder="Tìm kiếm"
                  ></b-form-input>
                </b-form-group>
              </b-form>
            </div>

            <div class="col-md-3">
              <b-form>
                <b-form-group>
                  <b-form-select
                    v-model="selectedType"
                    :options="typeOptions"
                    v-on:input="onFilter"
                    style="marginleft: auto"
                    size="sm"
                    class="col-md-12 form-control-sm select-style"
                  ></b-form-select>
                </b-form-group>
              </b-form>
            </div>

            <div class="col-md-3">
              <b-form>
                <b-form-group>
                  <b-form-select
                    v-model="selectedStatus"
                    :options="statusOptions"
                    v-on:input="onFilter"
                    style="marginleft: auto"
                    size="sm"
                    class="col-md-12 form-control-sm select-style"
                  ></b-form-select>
                </b-form-group>
              </b-form>
            </div>
          </div>
        </div>

        <div>
          <div
            v-if="filterParentId"
            class="mb-2 text-muted small"
          >
            <span>Đang lọc theo NCC chính:</span>
            <b-badge
              variant="light-primary"
              class="ml-1 cursor-pointer"
              @click="clearFilterByParent"
            >
              {{ filterParentName || filterParentId }} <i class="fas fa-times ml-1"></i>
            </b-badge>
          </div>
          <ProviderListTable
            :items="providers"
            :loading="onLoading"
            :fields="fields"
            @edit-item="editItem"
            @delete-item="showDeleteAlert"
            @filter-by-parent="onFilterByParent"
          />
        </div>
        <b-row>
          <b-col>
            <p
              class="mt-3 text-dark"
              style="font-weight: 500"
            >
              Tổng:
              {{ totalItems }}
            </p>
          </b-col>
          <b-col>
            <b-pagination-nav
              v-show="totalPages >= 2"
              class="custom-pagination"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              @change="fetchProvider"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm m-1"
              prev-class="page-item-prev btn btn-icon btn-sm m-1"
              next-class="page-item-next btn btn-icon btn-sm m-1"
              last-class="page-item-last btn btn-icon btn-sm m-1"
              page-class="btn btn-icon btn-sm border-0 m-1"
            >
              <template v-slot:first-text>
                <span>
                  <i class="ki ki-bold-double-arrow-back icon-xs"></i>
                </span>
              </template>

              <template v-slot:prev-text>
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </template>

              <template v-slot:next-text>
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </template>

              <template v-slot:last-text>
                <span class="text-info">
                  <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                </span>
              </template>
            </b-pagination-nav>
          </b-col>
        </b-row>
      </template>
    </KTCodePreview>

    <ProviderExportModal
      ref="exportModal"
      :search-params="getSearchParams"
      :total-items="totalItems"
      @export-success="handleExportSuccess"
    />

    <ProviderImportModal
      ref="importModal"
      @import-success="handleImportSuccess"
    />
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import KTCodePreview from '@/view/content/CodePreview.vue';
import Swal from 'sweetalert2';
import localData from '../../../utils/saveDataToLocal';
import ProviderExportModal from './components/ProviderExportModal.vue';
import ProviderImportModal from './components/ProviderImportModal.vue';
import ProviderListTable from './components/ProviderListTable.vue';

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Nhà cung cấp', route: '/providers' },
      { title: 'Danh sách nhà cung cấp', route: '/providers' },
    ]);
  },
  data() {
    return {
      onLoading: false,
      currentSort: 'name',
      currentSortDir: 'desc',
      id: '',
      name: '',
      phoneNo: '',
      totalPages: 1,
      count: 1,
      totalItems: 0,
      page: 1,
      currentPage: 1,
      providers: [],
      selectedStatus: null,
      query: '',
      statusOptions: [
        { value: null, text: 'Lọc theo trạng thái' },
        { value: '1', text: 'Đang giao dịch' },
        { value: '2', text: 'Ngưng giao dịch' },
      ],
      selectedType: null,
      typeOptions: [
        { value: null, text: 'Lọc theo loại' },
        { value: '1', text: 'Cá nhân' },
        { value: '2', text: 'Doanh nghiệp' },
      ],
      filterParentId: null,
      filterQueryBy: null,
      filterParentName: '',
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
          },
          tdClass: 'sttClass',
          required: true, // STT is always required
          nonResizable: true,
        },
        {
          key: 'name',
          label: 'Tên',
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'supplierGroupName',
          label: 'Nhóm NCC',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'email',
          label: 'Liên hệ',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'address',
          label: 'Địa chỉ',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'type',
          label: 'Loại',
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: { fontWeight: 600, color: '#181c32', width: '120px' },
        },
        {
          key: 'actions',
          label: '',
          // required: true, // Actions column is always required
          thStyle: { width: '50px' },
          nonResizable: true,
        },
      ],
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
    };
  },
  components: {
    KTCodePreview,
    ProviderListTable,
    ProviderExportModal,
    ProviderImportModal,
  },
  methods: {
    deleteItem: async function (item) {
      ApiService.delete('v1/providers' + '/' + item.id)
        .then((data) => {
          const { message } = data.data;

          this.makeToastSuccess(message);
          this.fetchProvider();
        })
        .catch((err) => {
          this.makeToastFaile(err.response.data.message);
        });
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa nhà cung cấp!',
        text: 'Bạn có chắc muốn xóa nhà cung cấp này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },
    editItem: function (item) {
      this.$router.push({
        name: 'update-provider',
        query: { id: item.id },
      });
    },

    onFilterByParent(payload) {
      const id = payload && (payload.id ?? payload);
      const name = payload && payload.name;
      const queryBy = payload && payload.queryBy;
      this.filterParentId = id;
      this.filterParentName = name || '';
      this.filterQueryBy = queryBy || null;
      this.page = 1;
      this.$router.replace({ query: { ...this.$route.query, page: 1 } }).catch(() => {});
      this.fetchProvider();
    },

    clearFilterByParent() {
      this.filterParentId = null;
      this.filterParentName = '';
      this.filterQueryBy = null;
      this.page = 1;
      this.$router.replace({ query: { ...this.$route.query, page: 1 } }).catch(() => {});
      this.fetchProvider();
    },

    fetchProvider: async function () {
      this.onLoading = true;
      this.page = this.$route.query.page;
      if (!this.page) {
        this.page = 1;
      }
      const param = {
        page: this.page,
        pageSize: 10,
        name: this.name,
        phoneNo: this.phoneNo,
        type: this.selectedType,
        status: this.selectedStatus,
        includeSupplierGroup: true,
        includeParent: true,
      };
      if (this.filterParentId != null && this.filterQueryBy === 'parentId') {
        param.parentId = this.filterParentId;
      } else if (this.filterParentId != null && this.filterQueryBy === 'id') {
        param.id = this.filterParentId;
      } else {
        param.id = this.id;
      }

      const paramQuery = {
        params: param,
      };
      ApiService.query('v1/providers', paramQuery)
        .then((response) => {
          this.providers = [];
          this.totalPages =
            response.data.data.totalPages > 0
              ? response.data.data.totalPages
              : 1;
          this.totalItems = response.data.data.totalItems;
          this.currentPage = response.data.data.currentPage;
          this.providers = response.data.data.providers.map((item, index) => {
            return {
              count:
                this.currentPage >= 2
                  ? index + 1 + this.currentPage * 10 - 10
                  : index + 1,
              id: item.id,
              code: item.code,
              supplierGroupName: item.supplierGroup?.name || '',
              name: item.name,
              phoneNo: item.phoneNo,
              email: item.email,
              taxNo: item.taxNo,
              type:
                item.type === 1
                  ? 'Cá nhân'
                  : item.type === null
                  ? ''
                  : 'Doanh nghiệp',
              identityCard: item.identityCard,
              address: item.address,
              bank: item.bank,
              bankBranch: item.bankBranch,
              bankAccountNo: item.bankAccountNo,
              bankAccountName: item.bankAccountName,
              representative: item.representative,
              repPosition: item.repPosition,
              repPhoneNo: item.repPhoneNo,
              status: item.status,
              statusName:
                item.status === 1
                  ? 'Đang giao dịch'
                  : item.status === null
                  ? ''
                  : 'Ngưng giao dịch',
              parentId: item.parentId ?? item.parent?.id ?? null,
              parentName: item.parentName || item.parent?.name || '',
            };
          });
          this.onLoading = false;
        })
        .catch(() => {
          this.onLoading = false;
        });
    },
    makeToastSuccess(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true,
      });
    },
    makeToastFaile(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
    checkStatus: function (item) {
      if (item.status === 'Đang giao dịch') {
        return true;
      } else {
        return false;
      }
    },
    checkType: function (item) {
      if (item.type === 'Cá nhân') {
        return true;
      } else {
        return false;
      }
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
    checkViewOnly: function () {
      let count = 0;
      if (localData.checkPermission('EMPLOYEE_VIEW')) {
        count++;
      }
      if (localData.checkPermission('EMPLOYEE_UPDATE')) {
        count++;
      }
      if (count === 1) {
        return true;
      } else {
        return false;
      }
    },
    searchAutoComplete() {
      this.listResultSearch = this.providers
        .filter((it) =>
          new RegExp(this.itemChoice.name, 'i').test(it.productName),
        )
        .splice(0, 5);
    },
    onFilter() {
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-provider',
      });
      this.fetchProvider();
    },
    handleExport() {
      this.$refs.exportModal.showModal();
    },
    handleImport() {
      this.$refs.importModal.showModal();
    },
    handleExportSuccess() {
      console.log('Export completed successfully');
    },
    handleImportSuccess() {
      this.fetchProvider();
    },
    handleColumnSettings() {
      this.$refs.columnModal.showModal();
    },
  },
  created() {
    this.fetchProvider();
  },
  computed: {
    getSearchParams() {
      return {
        name: this.name,
        phoneNo: this.phoneNo,
        type: this.selectedType,
        status: this.selectedStatus,
      };
    },
  },
};
</script>

<style lang="scss">
.list-provider {
  input::-webkit-calendar-picker-indicator {
    display: none;
  }
  .tableStatus {
    width: 1%;
  }

  .sttClass {
    width: 20px;
  }
  .icon:hover {
    background-color: #90c6fc;
  }

  .swal2-cancel:swal2-styled {
    color: black;
  }

  .page-item.disabled {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }
}
</style>
